import config from 'constants/config'

export function buildAgentHubQuotingURL(id: string, opts?: { currency?: string, region?: string }) {
  const urlSearchParams = new URLSearchParams()
  if (opts?.currency) {
    urlSearchParams.append('currency', opts.currency)
  }
  if (opts?.region) {
    urlSearchParams.append('region', opts.region)
  }
  return `${config.AGENT_PORTAL_URL}/offers/${id}/campaign-manager?${urlSearchParams.toString()}`
}
